import React, { useEffect } from 'react';
import { Row, Col, Button, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import LearnMoreModal from '../Components/layout/LearnMoreModal';
import { isBuiltInActivity, DEFAULT_TEXTS_IN_TEST, DEFAULT_TEXT_LANGUAGE, DEFAULT_TEXT_UNIT,
  DEFAULT_TARGETS_IN_TEST, DEFAULT_TARGET_SIZE, DEFAULT_TARGET_TYPE,
  DEFAULT_HITS_IN_TEST,
  TD_POINTING_HELP, TD_SWITCH_HELP, TD_TEXT_ENTRY_HELP, TD_GENERAL_HELP, TEST_DRIVE_ACTIVITIES } from './ConstForTestDriveSection';
import './Views.scss';
import TypingTest from '../Components/tests/TypingTest';
import TargetTest from '../Components/tests/TargetTest';
import ReactionTest from '../Components/tests/ReactionTest';
import {QRCodeSVG} from 'qrcode.react';
import TestDriveDevSidebar from './TestDriveDevSidebar';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  activeTestDriveCurrentActivity: PropTypes.string,
  activeTestDriveCurrentActivityName: PropTypes.string,
  activeTestDriveCurrentActivityNotes: PropTypes.string,
  activeTestDriveCurrentActivityNumTexts: PropTypes.string,
  activeTestDriveCurrentActivityLanguage: PropTypes.string,
  activeTestDriveCurrentActivityTextUnit: PropTypes.string,
  activeTestDriveCurrentActivityNumTargets: PropTypes.string,
  activeTestDriveCurrentActivityTargetSize: PropTypes.string,
  activeTestDriveCurrentActivityTargetType: PropTypes.string,
  activeTestDriveCurrentActivityNumPrompts: PropTypes.string,
  activeTestDriveCurrentActivityPromptType: PropTypes.string,
  activeTestDriveCurrentActivityComponentStats: PropTypes.arrayOf(PropTypes.object),
  // builtInActivityComplete: PropTypes.bool,
  // onBuiltInActivityComplete: PropTypes.func.isRequired,
  activeTestDriveCurrentActivityComplete: PropTypes.bool,
  onActiveTestDriveCurrentActivityComplete: PropTypes.func.isRequired,
  onChangeActiveTestDriveCurrentActivityNotes: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  activeTestDriveCurrentActivity: '',
  activeTestDriveCurrentActivityName: '',
  activeTestDriveCurrentActivityNotes: '',
  activeTestDriveCurrentActivityNumTexts: '',
  activeTestDriveCurrentActivityLanguage: '',
  activeTestDriveCurrentActivityTextUnit: '',
  activeTestDriveCurrentActivityNumTargets: '',
  activeTestDriveCurrentActivityTargetSize: '',
  activeTestDriveCurrentActivityTargetType: '',
  activeTestDriveCurrentActivityNumPrompts: '',
  activeTestDriveCurrentActivityPromptType: '',
  activeTestDriveCurrentActivityComponentStats: []
};

//content sub-component with unique content for this page
function TestDriveTryDoContent(props) {
  const {
    firstName,
    pronouns,
    runOnSameComputer,
    runningPractice,
    testDriveUrl,
    disableInput,
    activeTestDriveCurrentActivity,
    activeTestDriveCurrentActivityNumTexts,
    activeTestDriveCurrentActivityLanguage,
    activeTestDriveCurrentActivityTextUnit,
    activeTestDriveCurrentActivityNumTargets,
    activeTestDriveCurrentActivityTargetSize,
    activeTestDriveCurrentActivityTargetType,
    activeTestDriveCurrentActivityNumPrompts,
    activeTestDriveCurrentActivityPromptType,
    // builtInActivityComplete,
    // onBuiltInActivityComplete,
    activeTestDriveCurrentActivityComplete,
    onActiveTestDriveCurrentActivityComplete,
    activeTestDriveCurrentActivityNotes,
    onChangeActiveTestDriveCurrentActivityNotes,
    activeTestDriveCurrentActivityComponentStats,
    saveActivityResultsToLocalState,
    onContinue,
  } = props;

  console.log("Rendering TestDriveTryDoContent, props: " + JSON.stringify(props));
  return(
    <>
    {(activeTestDriveCurrentActivity===TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY || !activeTestDriveCurrentActivity) && 
      <DoOwnActivity
        firstName={firstName}
        activeTestDriveCurrentActivityNotes={activeTestDriveCurrentActivityNotes}
        onChangeActiveTestDriveCurrentActivityNotes={onChangeActiveTestDriveCurrentActivityNotes}
      />
    }
    {(activeTestDriveCurrentActivity===TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC) && 
      <DoTextEntryActivity
        firstName={firstName}
        runningPractice={runningPractice}
        runOnSameComputer={runOnSameComputer}
        disableInput={disableInput}
        testDriveUrl={testDriveUrl}
        numTexts={activeTestDriveCurrentActivityNumTexts}
        language={activeTestDriveCurrentActivityLanguage}
        textUnit={activeTestDriveCurrentActivityTextUnit}
        activeTestDriveCurrentActivityComplete={activeTestDriveCurrentActivityComplete}
        onActiveTestDriveCurrentActivityComplete={onActiveTestDriveCurrentActivityComplete}
        activeTestDriveCurrentActivityNotes={activeTestDriveCurrentActivityNotes}
        onChangeActiveTestDriveCurrentActivityNotes={onChangeActiveTestDriveCurrentActivityNotes}
        activeTestDriveCurrentActivityComponentStats={activeTestDriveCurrentActivityComponentStats}
        saveActivityResultsToLocalState={saveActivityResultsToLocalState}
      />
    }
    {(activeTestDriveCurrentActivity===TEST_DRIVE_ACTIVITIES.POINTING_BASIC) && 
      <DoPointingActivity
        firstName={firstName}
        runningPractice={runningPractice}
        runOnSameComputer={runOnSameComputer}
        disableInput={disableInput}
        testDriveUrl={testDriveUrl}
        numTargets={activeTestDriveCurrentActivityNumTargets}
        targetSize={activeTestDriveCurrentActivityTargetSize}
        targetType={activeTestDriveCurrentActivityTargetType}
        activeTestDriveCurrentActivityComplete={activeTestDriveCurrentActivityComplete}
        onActiveTestDriveCurrentActivityComplete={onActiveTestDriveCurrentActivityComplete}
        activeTestDriveCurrentActivityNotes={activeTestDriveCurrentActivityNotes}
        onChangeActiveTestDriveCurrentActivityNotes={onChangeActiveTestDriveCurrentActivityNotes}
        activeTestDriveCurrentActivityComponentStats={activeTestDriveCurrentActivityComponentStats}
        saveActivityResultsToLocalState={saveActivityResultsToLocalState}
      />
    }
    {(activeTestDriveCurrentActivity===TEST_DRIVE_ACTIVITIES.SWITCH_BASIC) && 
      <DoSwitchActivity
        firstName={firstName}
        runningPractice={runningPractice}
        runOnSameComputer={runOnSameComputer}
        disableInput={disableInput}
        testDriveUrl={testDriveUrl}
        numPrompts={activeTestDriveCurrentActivityNumPrompts}
        promptType={activeTestDriveCurrentActivityPromptType}
        activeTestDriveCurrentActivityComplete={activeTestDriveCurrentActivityComplete}
        onActiveTestDriveCurrentActivityComplete={onActiveTestDriveCurrentActivityComplete}
        activeTestDriveCurrentActivityNotes={activeTestDriveCurrentActivityNotes}
        onChangeActiveTestDriveCurrentActivityNotes={onChangeActiveTestDriveCurrentActivityNotes}
        activeTestDriveCurrentActivityComponentStats={activeTestDriveCurrentActivityComponentStats}
        saveActivityResultsToLocalState={saveActivityResultsToLocalState}
      />
    }

    {/* Include an End button for activities that aren't built-in */}
    {(!isBuiltInActivity(activeTestDriveCurrentActivity))
      && 
      <Row className="aa-review-row">
        <Col>
          <Button onClick={onContinue}>End the activity</Button>  
        </Col>
      </Row>
    }
    {/* show QR / link when running activity on other device (built-in activities only)*/}
    {(isBuiltInActivity(activeTestDriveCurrentActivity))
      && (runOnSameComputer === 'false')
      && !activeTestDriveCurrentActivityComplete 
      && 
      (<RemoteActivityQRLink testDriveUrl={testDriveUrl} runningPractice={runningPractice}/>)
    }
    </>
  );
}

function DoOwnActivity(props){
  const{
    firstName,
    activeTestDriveCurrentActivityNotes,
    onChangeActiveTestDriveCurrentActivityNotes
  } = props;

  return(
    <div>
      <p><strong>Running the activity on this computer?</strong> Switch to the activity you set up now. Then enter observations here once you're done with the activity.</p>

      <p><strong>If your Test-drive activity is on another device,</strong> feel free to jot down your observations while {firstName} goes through this activity.</p>
      <TestDriveTryDoNotes 
        notes={activeTestDriveCurrentActivityNotes}
        onChange={onChangeActiveTestDriveCurrentActivityNotes}
      />
      <p>When you and {firstName} think you've explored enough for now, hit the End button to stop this Test-drive activity.</p>   
    </div>
  )
}


function DoTextEntryActivity(props){
  const{
    firstName,
    testDriveUrl,
    runningPractice,
    runOnSameComputer,
    disableInput,
    // builtInActivityComplete,
    // onBuiltInActivityComplete,
    activeTestDriveCurrentActivityComplete,
    onActiveTestDriveCurrentActivityComplete,
    activeTestDriveCurrentActivityNotes,
    onChangeActiveTestDriveCurrentActivityNotes,
    activeTestDriveCurrentActivityComponentStats,
    saveActivityResultsToLocalState
  } = props;

  let {
    numTexts = DEFAULT_TEXTS_IN_TEST, //covers case if numTextss is undefined
    language = DEFAULT_TEXT_LANGUAGE,
    textUnit = DEFAULT_TEXT_UNIT
  } = props;

  numTexts = numTrialsNumber(numTexts, DEFAULT_TEXTS_IN_TEST);

  //put the parts of the activity (the UI and the results) in the same div, for styling.
  //then include Notes if the test has been completed
  return(
    <>
    {showActivityUI(runOnSameComputer, activeTestDriveCurrentActivityComplete, testDriveUrl)
      &&
      <div className="aa-typing-test-container">
        <TypingTest
          runningPractice={runningPractice}
          disableInput={disableInput}
          finished={activeTestDriveCurrentActivityComplete}
          setFinished={onActiveTestDriveCurrentActivityComplete}
          statsToDisplay={activeTestDriveCurrentActivityComponentStats}
          numTrials={numTexts}
          language={language}
          textUnit={textUnit}
          saveActivityResultsToLocalState={saveActivityResultsToLocalState}
        />
      </div>
    }
    <div>
      {activeTestDriveCurrentActivityComplete && !runningPractice && 
        <>
        <TestDriveTryDoNotes 
          notes={activeTestDriveCurrentActivityNotes}
          onChange={onChangeActiveTestDriveCurrentActivityNotes}
        />
        </>
      }
    </div>
    </>
  )
}

//handle the fact that the UI gives back a string from the text field.
//convert that to a number and establish default if the conversion goes south
function numTrialsNumber(numTrials, defaultVal){
  if(typeof numTrials === 'string'){
    numTrials = Number(numTrials);
    if (numTrials < 1){
      numTrials = defaultVal;
    }
  }
  return numTrials;
}

function DoPointingActivity(props){
  const{
    firstName,
    runningPractice,
    runOnSameComputer,
    disableInput,
    testDriveUrl,
    activeTestDriveCurrentActivityComplete,
    onActiveTestDriveCurrentActivityComplete,
    activeTestDriveCurrentActivityNotes,
    onChangeActiveTestDriveCurrentActivityNotes,
    activeTestDriveCurrentActivityComponentStats,
    saveActivityResultsToLocalState
  } = props;

  let {
    numTargets = DEFAULT_TARGETS_IN_TEST,
    targetSize = DEFAULT_TARGET_SIZE,
    targetType = DEFAULT_TARGET_TYPE
  } = props;

  numTargets = numTrialsNumber(numTargets, DEFAULT_TARGETS_IN_TEST);
  targetSize = numTrialsNumber(targetSize, DEFAULT_TARGET_SIZE);

  // var speedLabel = "Time per target (sec)";
  // var speedId = "time-per-target";
  // var accLabel = "Accuracy (%)";
  // var accId = "click-accuracy";

  console.log("Rendering DoPointingActivity, props: " + JSON.stringify(props));

  return(
    <>
    {showActivityUI(runOnSameComputer, activeTestDriveCurrentActivityComplete, testDriveUrl)
      &&
      <div className="aa-typing-test-container">
        <TargetTest
          runningPractice={runningPractice}
          disableInput={disableInput}
          numTrials={numTargets}
          targetSize={targetSize}
          targetType={targetType}
          finished={activeTestDriveCurrentActivityComplete}
          setFinished={onActiveTestDriveCurrentActivityComplete}
          statsToDisplay={activeTestDriveCurrentActivityComponentStats}
          saveActivityResultsToLocalState={saveActivityResultsToLocalState}
        />
      </div>
    }
    <div>
      {activeTestDriveCurrentActivityComplete && !runningPractice && 
        <>
        <TestDriveTryDoNotes 
          notes={activeTestDriveCurrentActivityNotes}
          onChange={onChangeActiveTestDriveCurrentActivityNotes}
        />
        </>
      }
    </div>
    </>
  )
}

function DoSwitchActivity(props){
  const{
    firstName,
    runningPractice,
    runOnSameComputer,
    disableInput,
    testDriveUrl,
    activeTestDriveCurrentActivityComplete,
    onActiveTestDriveCurrentActivityComplete,
    activeTestDriveCurrentActivityNotes,
    onChangeActiveTestDriveCurrentActivityNotes,
    activeTestDriveCurrentActivityComponentStats,
    saveActivityResultsToLocalState
  } = props;

  let {
    numPrompts = DEFAULT_HITS_IN_TEST, //covers case if numTexts is undefined
    promptType = DEFAULT_TARGET_TYPE
  } = props;

  return(
    <>
    {showActivityUI(runOnSameComputer, activeTestDriveCurrentActivityComplete, testDriveUrl)
      &&
      <div className="aa-typing-test-container">
        <ReactionTest
          runningPractice={runningPractice}
          disableInput={disableInput}
          numTrials={numPrompts}
          targetType={promptType}
          finished={activeTestDriveCurrentActivityComplete}
          setFinished={onActiveTestDriveCurrentActivityComplete}
          statsToDisplay={activeTestDriveCurrentActivityComponentStats}
          saveActivityResultsToLocalState={saveActivityResultsToLocalState}
        />
      </div>
    }
    <div>
      {activeTestDriveCurrentActivityComplete && !runningPractice && 
        <>
        <TestDriveTryDoNotes 
          notes={activeTestDriveCurrentActivityNotes}
          onChange={onChangeActiveTestDriveCurrentActivityNotes}
        />
        </>
      }
    </div>
    </>
  )
}

//component to provide QR and link to run activity remotely (built-in activities only)
function RemoteActivityQRLink(props){
  const {
    testDriveUrl,
    runningPractice
  } = props;

  return(
    <>
    {testDriveUrl &&
    <>
      <p>Using the other device, do one of the following:</p>
      <Row className="aa-review-row">
        <Col>
          <p><strong>Method 1. </strong>Scan this QR code:</p>
          <QRCodeSVG value={testDriveUrl} />
        </Col>
      </Row>
      <Row className="aa-review-row border-top">
        <Col>
          <div>-- <strong>OR</strong> --</div>
        </Col>
      </Row>
      <Row className="aa-review-row border-top">
        <Col>
          <p><strong>Method 2. </strong>Go to this link:</p>
          <div>{testDriveUrl}</div>
        </Col>
      </Row>
      {!runningPractice
        &&
        <Row className="aa-review-row border-top">
          <Col>
            Results will appear here automatically when the activity is complete.
          </Col>
        </Row>
      }
    </>
    }
    </>  
  )
}

//component to enter data manually:
function TestDriveTryDoData(props){
  const {
    label,
    data,
    helpTitle,
    helpContent,
    onChange,
    id
  } = props;

  return(
    <Row>
      <Col md="4">
        <FormGroup>
          <Label for={id} className="aa-bold-text">
            {label}: 
          </Label>
          {' '}
          <LearnMoreModal linkText="" 
            buttonClassName="float-end aa-no-padding aa-secondary-link" 
            title={helpTitle || 'test'} 
            content={helpContent || 'No help found'}
          />
          <Input
            id={id}
            value={data}
            onChange={onChange}
            name="test-drive-label"
            type="textfield"
            autoFocus={false}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

//component to enter observations:
function TestDriveTryDoNotes(props){
  const {
    notes,
    onChange
  } = props;

  return(
    <FormGroup>
      <Label for="test-drive-notes" className="aa-bold-text">
        Your observations:
      </Label>
      <Input
        id="test-drive-notes"
        value={notes}
        onChange={onChange}
        name="test-drive-notes"
        type="textarea"
        autoFocus={true}
      />
    </FormGroup>
  );
}

function getTitle(activityType, runningPractice, showActivity=true) {
  let title = "";
  let practiceLabel = "";
  let deviceLabel = "";

  if( runningPractice){
    practiceLabel = "Practice: ";
  }
  if( !showActivity){
    deviceLabel = " - run on another device";
  }
  switch(activityType){
    case TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC:
      title = practiceLabel + `Text entry activity` + deviceLabel;
      break;
    case TEST_DRIVE_ACTIVITIES.POINTING_BASIC:
      title = practiceLabel + `Point-and-click activity` + deviceLabel;
      break;
    case TEST_DRIVE_ACTIVITIES.SWITCH_BASIC:
      title = practiceLabel + `Basic switch activity` + deviceLabel;
      break;
    default:
      title = `Test-drive activity in progress!` + deviceLabel;
  }

  return title;
}

function getSubtitle(activityType, activityName, showActivity=true) {
  let subTitle = "";
  
  if (activityType === TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY && activityName) {
    subTitle = `Activity: ${activityName}`;
  }
  if(showActivity){
    if (activityType === TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC){
      subTitle = `Copy the sentence, then hit Enter.`;
    }
    else if (activityType === TEST_DRIVE_ACTIVITIES.POINTING_BASIC){
      subTitle = `Click the target when it appears.`;
    }
    else if (activityType === TEST_DRIVE_ACTIVITIES.SWITCH_BASIC){
      subTitle = `Press any key or click in the shaded area when the circle appears. `
    }  
  }
  return subTitle;
}

function getHelpContent(activityType) {
  let help = "";

  if (activityType === TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC){
    help = TD_TEXT_ENTRY_HELP;
  }
  else if (activityType === TEST_DRIVE_ACTIVITIES.POINTING_BASIC){
    help = TD_POINTING_HELP;
  }
  else if (activityType === TEST_DRIVE_ACTIVITIES.SWITCH_BASIC){
    help = TD_SWITCH_HELP;
  }
  else
    help = TD_GENERAL_HELP;

  return help;
}

//Return true to show the activity UI (e.g., sentence and text field)
//testDriveUrl is empty on the remote computer, so !testDriveUrl means show the activity!
function showActivityUI(runOnSameComputer, activityComplete, testDriveUrl){
  return(
    (runOnSameComputer==='true') || activityComplete || !testDriveUrl
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveTryDo(props) {
  const{
    firstName,
    pronouns,
    runOnSameComputer,
    runningPractice,
    testDriveUrl, //the URL for running an activity on a remote device. It is *empty* on the remote device itself.
    disableInput,
    activeTestDriveCurrentActivity,
    activeTestDriveCurrentActivityNumTexts,
    activeTestDriveCurrentActivityLanguage,
    activeTestDriveCurrentActivityTextUnit,
    activeTestDriveCurrentActivityNumTargets,
    activeTestDriveCurrentActivityTargetSize,
    activeTestDriveCurrentActivityTargetType,
    activeTestDriveCurrentActivityNumPrompts,
    activeTestDriveCurrentActivityPromptType,
    activeTestDriveCurrentActivityComplete,
    onActiveTestDriveCurrentActivityComplete,
    // builtInActivityComplete,
    // onBuiltInActivityComplete,
    activeTestDriveCurrentActivityName,
    activeTestDriveCurrentActivityNotes,
    onChangeActiveTestDriveCurrentActivityNotes,
    activeTestDriveCurrentActivityComponentStats,
    saveActivityResultsToLocalState,
    saveFormData,
    onContinue,
  } = props;

  const dev = props.dev || {};
  
  let showActivity = showActivityUI(runOnSameComputer, activeTestDriveCurrentActivityComplete, testDriveUrl);
  let title = getTitle(activeTestDriveCurrentActivity, runningPractice, showActivity);
  let subTitle = getSubtitle(activeTestDriveCurrentActivity, activeTestDriveCurrentActivityName, showActivity);
  let helpContent = getHelpContent(activeTestDriveCurrentActivity);

  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "fa-road aa-fa-3x",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: title,
    subTitle: subTitle,
    learnMore: {linkText: "Learn More about this activity",
                title: "More about this activity",
                content: helpContent
                },
    nextRoute: "", //not needed since we are using onContinue
    continueDisabled: (activeTestDriveCurrentActivity===TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC) 
      && !activeTestDriveCurrentActivityComplete,
    sidebar: false
  }

  //don't show the sidebar during an activity on the remote device
  let showDevSidebar = dev.showDevSidebar && testDriveUrl; 

  console.log("Rendering TestDriveTryDo, props: " + JSON.stringify(props));

  useEffect(() => {
    console.log('TDTDo mounted');
    return () => {
      console.log('@@@@ TDTDo unmounted and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <TestDriveTryDoContent 
          firstName={firstName}
          pronouns={pronouns}
          runOnSameComputer={runOnSameComputer}
          runningPractice={runningPractice}
          testDriveUrl={testDriveUrl}
          disableInput={disableInput}
          activeTestDriveCurrentActivity={activeTestDriveCurrentActivity}
          activeTestDriveCurrentActivityNumTexts={activeTestDriveCurrentActivityNumTexts}
          activeTestDriveCurrentActivityLanguage={activeTestDriveCurrentActivityLanguage}
          activeTestDriveCurrentActivityTextUnit={activeTestDriveCurrentActivityTextUnit}
          activeTestDriveCurrentActivityNumTargets={activeTestDriveCurrentActivityNumTargets}
          activeTestDriveCurrentActivityTargetSize={activeTestDriveCurrentActivityTargetSize}
          activeTestDriveCurrentActivityTargetType={activeTestDriveCurrentActivityTargetType}
          activeTestDriveCurrentActivityNumPrompts={activeTestDriveCurrentActivityNumPrompts}
          activeTestDriveCurrentActivityPromptType={activeTestDriveCurrentActivityPromptType}
          activeTestDriveCurrentActivityComplete={activeTestDriveCurrentActivityComplete}
          onActiveTestDriveCurrentActivityComplete={onActiveTestDriveCurrentActivityComplete}
          activeTestDriveCurrentActivityNotes={activeTestDriveCurrentActivityNotes}
          onChangeActiveTestDriveCurrentActivityNotes={onChangeActiveTestDriveCurrentActivityNotes}
          activeTestDriveCurrentActivityComponentStats={activeTestDriveCurrentActivityComponentStats}
          saveActivityResultsToLocalState={saveActivityResultsToLocalState}
          onContinue={onContinue}
        />
      } 
      sidebarComponent = {
        showDevSidebar && 
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
       />
      }
      onContinue={onContinue}  
    />
    </>
  );
}

TestDriveTryDo.propTypes = propTypes;
TestDriveTryDo.defaultProps = defaultProps;

export default TestDriveTryDo;